import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-093c81d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-avatar-container" }
const _hoisted_2 = { class: "select-avatar__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "header-title" }, "上传头像")
], -1))


const __default__ = {
  name: 'SelectAvatarDialog'
}

import { useMessage, NSpin } from 'naive-ui'
import Icon from '@teams/common/components/icon'
import Loading from '@teams/common/components/loading'
type DialogFuncType = typeof dialogFunc


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    onConfirm: null,
    onCancel: null,
    modelValue: null,
    loading: { type: Boolean }
  },
  emits: ['close', 'back', 'closeAll'],
  setup(__props: any, { emit }) {

const props = __props as { onConfirm?: (avatar: string, dialogFunc: DialogFuncType) => void, onCancel?: (dialogFunc: DialogFuncType) => void, modelValue?: string, loading?: boolean }


const dialogFunc = {
  close: (...args: unknown[]) => {
    emit('close', ...args)
  },
  back: (...args: unknown[]) => {
    emit('back', ...args)
  },
  closeAll: (...args: unknown[]) => {
    emit('closeAll', ...args)
  }
}



const message = useMessage()

const uploadProps = {
  headerOptions: {
    isShow: false
  },
  footerOptions: {
    isShow: true
  }
}

const confirm = async (value?: string) => {
  if (value) {
    if (props.onConfirm) {
      props.onConfirm(value, dialogFunc)
    } else {
      dialogFunc.back()
    }
  } else {
    message.error('请选择要上传的照片')
  }
}

const back = () => {
  if (props.onCancel) {
    props.onCancel(dialogFunc)
  } else {
    dialogFunc.back()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_k_upload_avatar = _resolveComponent("k-upload-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", {
        class: "header__icon header__icon--close",
        onClick: back
      }, [
        _createVNode(_unref(Icon), {
          name: "close",
          size: 16
        })
      ])
    ]),
    _createVNode(_unref(NSpin), {
      show: __props.loading,
      rotate: false
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_n_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Loading), {
              useType: 'pc',
              fill: "#234CF6"
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_k_upload_avatar, _mergeProps(uploadProps, {
          icon: __props.modelValue,
          onOnConfirm: confirm,
          onOnClose: back,
          onOnCancel: back
        }), null, 16, ["icon"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})